module.exports = __webpack_public_path__ + "static/media/family.19f767a0.png";